import Api from "../../utils/Api.jsx";
import Button from "../componentes/Button.jsx";
import React from "react";
import Row from "../componentes/Row.jsx";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import LabeledInput from "../componentes/LabeledInput.jsx";
import TelaLogout from "../componentes/TelaLogout.jsx";


class EsqueceuSenha extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            emailCorreto: true,
            bloqueiaBotao: false,
            displaySucess: false,
        };

        // Padrão do LTE:
        document.body.className = "hold-transition login-page";

        this.setInputEmailRef = (element) => {
            this.inputEmailRef = element;

        };
    }

 
    realizarValidacoes() {
        if (!this.state.email) {
            this.inputEmailRef.focus();
            toastr.error("Atenção!", "Informe o email!");
            return;
        }
        return true;
    }

    /**
     * Realiza a recuperação de senha no backend.
     */
    async realizarRecuperacaoSenha() {

        if (!this.realizarValidacoes()) {
            return;
        }

        try {

            this.setState({ bloqueiaBotao: true,
                displaySucess: false
             });
            const ret = await Api.recuperarSenha(
                this.state.email,
            );
            
            if (ret.status && ret.validado) {
                this.setState({
                    emailCorreto: true,
                    bloqueiaBotao: false,
                    displaySucess: true,
                })
                
            } else {
                this.setState({ emailCorreto: false })
                this.setState({ bloqueiaBotao: false })
            }
        } catch (ex) {
            toastr.error(
                "Erro!",
                "Rode o atualizador pelo console, provavelmente há um erro!"
            );
        }
    }

    renderBody() {
        return (
            <div className="login-box-body">
                <div className="stripe" />
                <div>
                    <div className="form-group has-feedback " style={{ position: "relative", width: "100%" }}>
                        <LabeledInput
                            label="E-mail do cadastro:"
                            subtitle="gu....o@api.....com.br"
                            placeholder="Digite seu email"
                            uppercase="false"
                            value={this.state.email}
                            inputRef={this.setInputEmailRef}
                            onChange={(e) => this.setState({ email: e.target.value })}
                            name={this.state.uuid}
                            autoComplete
                            style={{
                                height: '50px',
                                fontSize: '18px',
                            }}
                            labelStyle={{
                                color: 'black',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                marginBottom: '0px'
                            }}
                            subtitleStyle={{
                                marginBottom: "10px"
                            }}
                        />
                        <i className="fa fa-paper-plane form-control-feedback"
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "75%",
                                transform: "translateY(-50%)",
                                fontSize: "18px",
                            }} />
                    </div>
                    {
                        this.state.displaySucess ? <div>
                            <h4 style={{ color: "green" }}>E-mail validado, verifique o seu email para alterar sua senha</h4>
                        </div> : null
                    }
                    {
                        this.state.emailCorreto ? null : <div>
                            <h4 style={{ color: "red" }}>E-mail preenchido incorretamente, tente novamente</h4>
                        </div>
                    }
                    <Row>
                        <div className="col-sm-2 col-sm-offset-4 text-center"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "20px",
                                width: "35%",
                            }}>
                            <Button
                                icon="fa-arrow-left"
                                label="Voltar"
                                className="btn-primary"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.props.history.push("/");
                                }}
                                style={{
                                    width: '150px',
                                    height: '45px',
                                    fontSize: '18px',
                                    padding: '10px',
                                }}
                            />
                            <Button
                                icon="fa-paper-plane"
                                label="Enviar"
                                className="btn-primary"
                                onClick={this.realizarRecuperacaoSenha.bind(this)}
                                style={{
                                    marginLeft: '40px',
                                    width: '150px',
                                    height: '45px',
                                    fontSize: '18px',
                                    padding: '10px',
                                }}
                            />
                        </div>
                    </Row>
                </div>
            </div>
        );
    }



    render() {

        return (
            <div>
                <TelaLogout
                    renderBody={this.renderBody.bind(this)}
                    ref={e => this.esqueceuSenha = e}
                    focusFieldRef={() => this.inputEmailRef.focus()}
                />
            </div>


        );
    }
}

export default connect(
    (state) => ({
        socket: state.socket,
    }),
    (dispatch) => ({
        dispatch,
    })
)(EsqueceuSenha);




// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/EsqueceuSenha.jsx